import { AddNewNaturalPersonInputSchema } from './AddNewPerson'

export const DirectorInputSchema = AddNewNaturalPersonInputSchema.omit(['groupSignature'])
